<template>
  <div class="board">
    <div class="prductCategorym">
      <el-dropdown @command="selectProduct" trigger="click">
        <span style="color: white; font-size: 19px" class="el-dropdown-link">
          当前年份：{{ commandYear }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="item" v-for="(item, i) in yearList" :key="i">{{ item }} 年</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown><br />
      <span>更新时间：{{ updateTimeText }}</span>
    </div>
    <div @click="signOut" class="power">
      <i style="cursor: pointer; font-size: 0.55rem" class="el-icon-back"></i>
    </div>
    <div class="logoImg">
      <img style="height: 0.6rem" :src="logoSrc" />
    </div>
    <header>
      <el-button class="title" type="primary">{{ title ? title : '审核计划矩阵' }}</el-button>
    </header>
    <div style="padding: 12px; width: 100%">
      <el-tabs @tab-click="tabClick" v-model="activeName" type="card">
        <el-tab-pane v-for="(month, i) in months" :key="i" :label="month" :name="i + ''"></el-tab-pane>
      </el-tabs>
      <div class="table-show">
        <el-carousel style="height: 1024px" direction="vertical" :interval="10000">
          <el-carousel-item style="height: 1024px" v-for="carou in screen" :key="carou">
            <table class="table-wrapper">
              <thead>
                <tr>
                  <th style="width: 50px"></th>
                  <th>审核人员
                    <el-tooltip effect="dark" content="显示每月的审核计划，按审核计划结束时间查询(如果计划的结束日期在3月，就属于三月的计划)， 按审核岗位分组。"
                      placement="top-start">
                      <i class="el-icon-question" style="font-size:16px;"></i>
                    </el-tooltip>
                  </th>
                  <th v-for="(date, i) in dataSet['dates']" :key="i">
                    {{ i + 1 }}号
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(pageItems, pIndex) in dataSlice(carou, dataSet['data'])">
                  <template v-for="(item, i) in pageItems">
                    <!-- 分组标题行 -->
                    <tr v-if="item.type === 'header'" :key="'header-' + pIndex + '-' + i">
                      <td style="text-align: left; padding-left: 0.5rem" :colspan="dataSet.dates.length + 2">
                        <i class="el-icon-edit-outline" style="color: white; padding: 8px 0"></i>
                        {{ item.job }}
                      </td>
                    </tr>
                    <!-- 用户数据行 -->
                    <tr v-else-if="item.type === 'user'" :key="'user-' + pIndex + '-' + i">
                      <td>
                        {{ item.data.index }}
                      </td>
                      <td style="width: 3rem">
                        {{ item.data.name }}
                      </td>
                      <td v-for="(plan, m) in item.data['list']" :key="m">
                        <i class="el-icon-success" style="color: yellow; font-size: 18px"
                          v-if="plan.status == '0' || plan.status == '1'"></i>
                        <div v-if="plan.status == '2'">
                          <i class="el-icon-success" style="color: green; font-size: 18px"></i>
                          {{ plan.issueCount }}
                        </div>
                        <i class="el-icon-error" style="color: red; font-size: 18px" v-if="plan.status == '3'"></i>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import format from "date-fns/format";
import router from "../../../router";
export default {
  name: "board",
  data() {
    return {
      activeName: "first",
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      title: "审核计划矩阵",
      msg: "home",
      dataSet: { data: [], dates: [] },
      pagedData: [],
      loading: null,
      issueDialog: false,
      todoDialog: false,
      issueData: {},
      todoData: {},
      colors: { Y: "#FFCC00", R: "#f44", G: "#06bf04" },
      todoTitle: { title: "", groupTitle: "" },
      screen: 10,
      issueIndex: 0,
      months: [],
      yearList: [],
      commandYear: "",
      logoSrc: "/assets/img/logo_light.png",
      updateTimeText: null
    };
  },
  mounted() {
    //this.webSocket();

    this.onShow();

    this.initMonth();
    this.loadYear();
    this.loadBoardTitle();

    this.loadData(); //保留http

    //轮训加载
    setInterval(this.loadData, 60000);

  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    tabClick() {
      this.loadData();
    },
    signOut() {
      router.back();
    },
    initMonth() {
      this.months = [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月",
      ];
      this.activeName = new Date().getMonth() + ""; //获取当前月份(0-11,0代表1月)
    },
    loadData() {
      var now = new Date();
      now.setFullYear(this.commandYear);
      now.setMonth(this.activeName, 1);
      var params = { begin: now.setHours(0, 0, 0, 0) + "" };
      this.startLoading();
      API.loadPlanBoard(params)
        .then((res) => {
          if (res.success == true) {
            this.dataSet = res.value;
            this.fmData();
          } else {
            this.$message.error(res.message);
          }
          this.endLoading();
        })
        .catch((error) => {
          this.$message.error("网络错误,数据查询失败");
          this.endLoading();
        });
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });

      var params = { query: { name: "layeraudit" } };
      API.loadBoardTitle(params).then((re) => {
        if (re.success && re["list"].length > 0) {
          this.title = re["list"][0]["boardName"];
        }
      });
    },
    fmData() {
      var now = new Date();
      this.updateTimeText = format(now, "MM-dd HH:mm:ss");
      var datas = this.dataSet["data"];
      var index = 1;
      datas.forEach((re) => {
        re.data.forEach((m) => {
          m.list.forEach((d) => {
            var status = "-1";
            var issueCount = 0;
            if (d.dayList.length > 0) {
              var temp = null;
              d.dayList.forEach((t) => {
                var tmStatus = t["status"];
                issueCount = t["issueCount"];
                if (tmStatus == "3") {
                  temp = tmStatus;
                } else if (!"3" == temp && !"2" == tmStatus) {
                  temp = tmStatus;
                } else {
                  temp = tmStatus;
                }
              });
              status = temp;
            }
            d["issueCount"] = issueCount;
            d["status"] = status;
          });
          m["index"] = index;
          index++;
        });
      });

      // 重新计算分页：每页最多12条用户数据
      this.pagedData = [];
      var currentPage = [];
      var currentUserCount = 0;
      const maxUsersPerPage = 16;

      datas.forEach((group) => {
        // 如果当前页已有数据，且加入新分组会导致跨页，则先保存当前页
        if (currentUserCount >= maxUsersPerPage) {
          this.pagedData.push(currentPage);
          currentPage = [];
          currentUserCount = 0;
        }

        // 添加分组头
        currentPage.push({
          type: 'header',
          job: group.job,
          data: []
        });

        // 添加用户数据
        group.data.forEach((user) => {
          if (currentUserCount >= maxUsersPerPage) {
            // 当前页已满，保存并开始新页
            this.pagedData.push(currentPage);
            currentPage = [];
            currentUserCount = 0;
            // 新页需要重新添加分组头
            currentPage.push({
              type: 'header',
              job: group.job,
              data: []
            });
          }
          currentPage.push({
            type: 'user',
            data: user
          });
          currentUserCount++;
        });
      });

      // 添加最后一页
      if (currentPage.length > 0) {
        this.pagedData.push(currentPage);
      }

      this.screen = this.pagedData.length || 1;
    },
    dataSlice(index, data) {
      // 返回分页后的数据
      var open = index - 1;
      return this.pagedData.slice(open, index);
    },
    loadYear() {
      var now = new Date();
      this.commandYear = now.getFullYear(); //默认当前年
      API.loadPlanYearList().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.yearList = re["list"];
        }
      });
    },
    selectProduct(item) {
      this.commandYear = item || "";
      this.isload = true;
      this.loadData();
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/layeraudit/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/layeraudit/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("Layeraudit Plan socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("Layeraudit Plan 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" Layeraudit Plan 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
      }
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        console.log(time);
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>
<style>
.prductCategorym {
  color: white;
  position: absolute;
  right: 5%;
  top: 5px;
  z-index: 999999;
  line-height: 0.45rem;

}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/layeraudit/plan/board.vue